<div class="wvAch d-flex justify-content-around align-items-center" [ngClass]="hasBackdrop ? 'wvCustomItemDark' : 'wvCustomItemLight'">
    <div class="achViewport">
        <div class="achCarousel" [attr.mid]="moduleKey">
            <div class="aTileItem" >
                <div class="achTile" *ngFor="let item in achievementData">
                    <div class="aImage" [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + item.imgID + '&w=500&h=500)' }" *ngIf="!item.useAvatar"></div>
                    <div class="aImage" style="background-size:contain" [ngStyle]="{ 'background-image': 'url(../Admin/AvatarProfileImage.aspx?loginid=' + item.imgID + '&w=600&h=610)' }" *ngIf="item.useAvatar"></div>

                    <div class="aBadge">
                        <div class="aBadgeImg" [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + item.iconImageID + '&w=100&h=100)' }"></div>
                        {{item.activityText}}
                    </div>

                    <div class="aLoginName">
                        <div class="aName txtOverflow">{{item.loginName}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fadedEdges"></div>
